import React, { useEffect, useState } from "react";
import { FilterProperties } from "../../Models/FilterProperties";


const SortByProperties: React.FunctionComponent<{ filterOptionsValue: FilterProperties, OnSelectChangeSortBy: any, thead: string }> = (props) => {

    const [filterOptions, setFilterOptions] = useState<FilterProperties>(props.filterOptionsValue);

    useEffect(() => {
        setFilterOptions(props.filterOptionsValue)
    })
    const handleSelectSortBy = () => {
        setFilterOptions((prevState) => {
            const newState = {
                ...prevState,
                sortBy: props.thead,
                low_to_high: !prevState.low_to_high,
            };
            props.OnSelectChangeSortBy(newState);
            return newState;
        });
    };

    return (
        <button
            className="border-trans back-trans "
            type="button"
            onClick={handleSelectSortBy}
        >
            {filterOptions.low_to_high ? (
                <svg width="19" height="19" className="marg-left-5" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.13062 14.3321L9.03412 3.83255" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M13.5752 8.29101L9.03408 3.83256" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M4.57556 8.37372L9.03402 3.83255" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>

            ) : (
                <svg width="18" height="18" className="marg-left-5" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 3.75L9 14.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M4.5 9.75L9 14.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M13.5 9.75L9 14.25" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>

            )}
        </button>

    );
};

export default SortByProperties;
